// These values identify the frontend bundle loaded by this browser, not the
// current API deployment. Vite replaces them when the frontend is built.
const version = (import.meta.env.VITE_APP_VERSION as string | undefined)?.trim() || '';
const versionIsRevision = /^[a-f\d]{40}$/i.test(version);
const revision = (import.meta.env.VITE_APP_REVISION as string | undefined)?.trim() || '';
const environment = (import.meta.env.VITE_APP_ENV as string | undefined)?.trim() || 'local';
const environmentLabel =
  environment === 'production' ? '' : environment === 'staging' ? 'STG' : environment.toUpperCase();
const versionLabel = versionIsRevision || version === revision ? '' : version;
const identity = [versionLabel, revision.slice(0, 7)].filter(Boolean).join(' · ');

export const webBuildInfo = Object.freeze({
  version,
  revision,
  environment,
  label: [environmentLabel, identity || (environment === 'local' ? 'dev' : 'unknown')]
    .filter(Boolean)
    .join(' · '),
  details: `Environment: ${environment}\nVersion: ${version || 'unknown'}\nRevision: ${revision || 'unknown'}`,
});
